import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { PipesModule } from '../../../pipes/pipes.module';
import { GenericInputHintComponent } from './generic-input-hint.component';

export * from './generic-input-hint.component';

@NgModule({
    declarations: [ GenericInputHintComponent ],
    imports: [
        CommonModule,
        PipesModule,
        MatRippleModule,
    ],
    exports: [
        GenericInputHintComponent,
    ],
})
export class GenericInputHintModule {
}
